// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post, del } from "./api_client";
import { AlertRecipient, IAlertRecipient } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function list(organizationId?: string, facilityId?: string): ApiResult<AlertRecipient[]> {
		const queryParams = [organizationId !== undefined ? `organizationId=${organizationId}` : undefined,
			facilityId !== undefined ? `facilityId=${facilityId}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IAlertRecipient[]>(`/api/alertrecipient/${query}`).then(result => result === undefined ? undefined : result.map(o => new AlertRecipient(o)));
}

export async function create(body: AlertRecipient): ApiResult<AlertRecipient> {
	return post<IAlertRecipient>(`/api/alertrecipient`, body).then(result => result === undefined ? undefined :  new AlertRecipient(result));
}

export async function resendVerification(id?: string): ApiResult<AlertRecipient> {
	return post<IAlertRecipient>(`/api/alertrecipient/${ id }/resend-verification`).then(result => result === undefined ? undefined :  new AlertRecipient(result));
}

export async function deleteRecipient(id?: string): ApiResult<undefined> {
	return del(`/api/alertrecipient/${ id }`);
}
